import './beforeFooter.css';
import { useNavigate } from 'react-router-dom';
import bwgoEnCover from '../../assets/sales/2.png';
import inbetweenCover from '../../assets/sales/1.png';
import plannerCover from '../../assets/notionplanner.png';
import notionLogo from '../../assets/Notion-logo.svg.png';

const PRODUCTS = [
  {
    id: 'bwgo-en',
    title: 'Before We Get Older',
    subtitle: 'The 20 years Life Lessons',
    image: bwgoEnCover,
    type: 'Book',
    tag: null,
    tagLogo: null,
    link: '/order/bwgo',
    external: false,
  },
  {
    id: 'inbetween',
    title: 'The In-Between',
    subtitle: 'A Journey to Balance',
    image: inbetweenCover,
    type: 'Book',
    tag: 'New',
    tagLogo: null,
    link: '/order/inbetween',
    external: false,
  },
   {
     id: 'planner',
     title: 'The Annual Quest System',
     subtitle: 'Plan with intention',
     image: plannerCover,
    type: 'Digital Product',
     tag: null,
     tagLogo: notionLogo,
     link: 'https://www.notion.com/templates/the-annual-quest-system',
     external: true,
   },
];

function BeforeFooter() {
  const navigate = useNavigate();

  const handleClick = (product) => {
    if (product.external) {
      window.open(product.link, '_blank', 'noopener noreferrer');
    } else {
      navigate(product.link);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <section className="before-footer">
      <h2 className="before-footer-title">Explore My Creations</h2>

      <div className="products-wrapper">
        {PRODUCTS.map((item) => (
          <div
            key={item.id}
            className="product-card"
            onClick={() => handleClick(item)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleClick(item)}
          >
            <div className="product-image-wrap">
              <img src={item.image} alt={item.title} className="product-image" />

              {/* Text tag (e.g. "New") */}
              {item.tag && (
                <span className={`product-tag tag-${item.tag.toLowerCase()}`}>
                  {item.tag}
                </span>
              )}

              {/* Logo tag (e.g. Notion) */}
              {item.tagLogo && (
                <span className="product-tag-logo">
                  <img src={item.tagLogo} alt="platform logo" />
                </span>
              )}
            </div>

            <div className="product-info">
              <p className="product-type">{item.type}</p>
              <h3 className="product-title">{item.title}</h3>
              <p className="product-subtitle">{item.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="products-divider" />
    </section>
  );
}

export default BeforeFooter;